export default __webpack_public_path__ + "static/media/1948.283f255d.png";